export const routerDomain = 'router'
export const domain = 'RouterModel'

export const onPushRouteToHistoryStack = `${domain}/onPushRouteToHistoryStack`
export const onSetActiveRouteId = `${domain}/onSetActiveRouteId`
